import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-third-party',
  templateUrl: './third-party.component.html',
  styleUrls: ['./third-party.component.scss']
})
export class ThirdPartyComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
